@if (netzbetreiber) {
    <form #netzbetreiberForm="ngForm"
          [tnbUniqueTeilgebietAndNetzbetreibernummer]="{
          originalNetzbetreiberValues: originalNetzbetreiber,
          enabled: isWestnetzAdmin
      }"
          data-qa="netzbetreiber-detail-form"
          fxLayout="column">
        @if (isWestnetzUser) {
            <header>
                <div class="buttons-container">
                    <div class="buttons">
                        <button
                            (click)="closeSideNav()"
                            type="button"
                            class="actionbutton"
                            data-qa="close-details-button"
                            matButton="outlined">
                            <mat-icon svgIcon="innogy_picto_close"></mat-icon>
                            {{ (createNewMode || netzbetreiberForm.form.dirty) ? 'Abbrechen' : 'Schließen' }}
                        </button>
                        @if (!createNewMode && isWestnetzAdmin) {
                            <button
                                (click)="resetForm()"
                                [disabled]="!netzbetreiberForm.form.dirty"
                                type="reset"
                                class="actionbutton"
                                data-qa="reset-details-button"
                                matButton="outlined">
                                <mat-icon>autorenew</mat-icon>
                                Zurücksetzen
                            </button>
                        }
                        @if (!createNewMode && isWestnetzAdmin) {
                            <button
                                (click)="saveBasisDaten()"
                                [disabled]="isSaveButtonDisabled()"
                                type="button"
                                class="actionbutton"
                                data-qa="save-details-button"
                                matButton="filled">
                                <mat-icon>save</mat-icon>
                                Speichern
                            </button>
                        }
                        @if (createNewMode && isWestnetzAdmin) {
                            <button
                                (click)="createNetzbetreiber()"
                                [disabled]="isSaveButtonDisabled()"
                                type="button"
                                class="actionbutton"
                                data-qa="create-details-button"
                                matButton="filled">
                                <mat-icon>save</mat-icon>
                                Erstellen
                            </button>
                        }
                        @if (!createNewMode && isWestnetzAdmin) {
                            <button
                                (click)="deleteNetzbetreiber()"
                                [disabled]="isDeleteButtonDisabled()"
                                type="button"
                                class="actionbutton button-warn"
                                data-qa="delete-details-button"
                                matButton="filled">
                                <mat-icon svgIcon="innogy_picto_bin_c-check"></mat-icon>
                                Löschen
                            </button>
                        }
                        @if (getDeletedButtonTooltipText()) {
                            <mat-icon [matTooltip]="getDeletedButtonTooltipText()"
                                      aria-hidden="false"
                                      [attr.aria-label]="getDeletedButtonTooltipText()"
                                      svgIcon="innogy_picto_speech-bubble_exclamationmark"
                                      data-qa="deleteButtonDisabledIfDatenabfrageAktivHint"
                            >
                            </mat-icon>
                        }
                    </div>
                    @if (netzbetreiberForm.errors) {
                        <div class="text-align-end" fxLayout="row" fxLayoutAlign="end">
                            @if (netzbetreiberForm.hasError('uniqueTeilgebietName')) {
                                <mat-error>
                                    Die Kombination aus Teilgebiet & Netzbetreibernummer <br>
                                    (PGON) existiert bereits. Bitte vergeben Sie eine andere.
                                </mat-error>
                            }
                        </div>
                    }
                </div>
                <div class="stadtwerkeId">
                    <div>Netzbetreiber</div>
                    <span class="stadtwerkeId-title" data-qa="stadtwerkeName">
            @if (!createNewMode) {
                {{ originalNetzbetreiber.name }}
            }
                        @if (createNewMode) {
                            Neuer Netzbetreiber
                        }
          </span>
                </div>
            </header>
        }
        @if (isStadtwerkUser) {
            <header>
                <div class="buttons">
                    <button
                        [queryParams]="{stadtwerkeId: ''}"
                        [routerLink]="routingService.dashboard()"
                        class="actionbutton"
                        matButton="outlined">
                        <mat-icon svgIcon="innogy_picto_close"></mat-icon>
                        {{ netzbetreiberForm.form.dirty ? 'Abbrechen' : 'Schließen' }}
                    </button>
                    <button
                        (click)="resetForm()"
                        [disabled]="!netzbetreiberForm.form.dirty"
                        class="actionbutton"
                        matButton="outlined">
                        <mat-icon>autorenew</mat-icon>
                        Zurücksetzen
                    </button>
                    <button
                        (click)="saveContactData()"
                        [disabled]="isSaveButtonDisabled()"
                        class="actionbutton"
                        matButton="filled">
                        <mat-icon>save</mat-icon>
                        Speichern
                    </button>
                </div>
                <h2>Meine Kontaktdaten</h2>
            </header>
        }
        <div class="detail-main">
            <fieldset>
                <legend>Basis-Daten</legend>
                <mat-form-field>
                    <mat-label>Name des Netzbetreibers</mat-label>
                    <input #name="ngModel"
                           [(ngModel)]="netzbetreiber.name"
                           [disabled]="!isWestnetzAdmin"
                           [readonly]="!isWestnetzAdmin"
                           data-qa="netzbetreiber-name-input"
                           matInput
                           name="name"
                           required/>
                    @if (name?.errors?.required) {
                        <mat-error>
                            Bitte vergeben Sie einen eindeutigen Namen
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Teilgebiet</mat-label>
                    <input #teilgebiet="ngModel"
                           [(ngModel)]="netzbetreiber.teilgebiet"
                           [disabled]="!isWestnetzAdmin"
                           [readonly]="!isWestnetzAdmin"
                           matInput
                           maxlength="40"
                           name="teilgebiet"
                           required/>
                    @if (teilgebiet?.errors?.required) {
                        <mat-error>
                            Bitte vergeben Sie einen Teilgebiet
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Netzbetreibernummer (PGON)</mat-label>
                    <input #netzbetreibernummer="ngModel"
                           [(ngModel)]="netzbetreiber.netzbetreibernummer"
                           [disabled]="!isWestnetzAdmin"
                           [readonly]="!isWestnetzAdmin"
                           data-qa="pgon-input-field"
                           (ngModelChange)="netzbetreibernummerChanged()"
                           matInput
                           name="netzbetreibernummer"/>
                    @if (netzbetreibernummer?.errors?.uniqueNetzbetreibernummer) {
                        <mat-error>
                            Diese Netzbetreibernummer ist bereits vergeben
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Stadtwerke-ID</mat-label>
                    <input #stadtwerkeId="ngModel"
                           [(ngModel)]="netzbetreiber.stadtwerkeId"
                           [disabled]="!isWestnetzAdmin"
                           [readonly]="!createNewMode"
                           [required]="createNewMode"
                           [tnbAvailableStadtwerkeId]="createNewMode"
                           data-qa="netzbetreiber-stadtwerke-id-input"
                           matInput
                           name="stadtwerkeId"
                           pattern="S[0-9]{3}"/>
                    @if (stadtwerkeId?.errors?.pattern) {
                        <mat-error>
                            Die Stadtwerke-ID entspricht nicht dem Muster
                        </mat-error>
                    }
                    @if (stadtwerkeId?.errors?.availableStadtwerkeId) {
                        <mat-error>
                            Diese Stadtwerke-Id ist bereits vergeben
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Dienstleistungsart</mat-label>
                    <input #dienstleistungsartTitle="ngModel"
                           [(ngModel)]="netzbetreiber.dienstleistungsartTitle"
                           [disabled]="!isWestnetzAdmin"
                           [readonly]="!isWestnetzAdmin"
                           matInput
                           name="dienstleistungsartTitle"/>
                </mat-form-field>
                <mat-form-field class="no-input">
                    <mat-label>
                        Erzeugungsanlagenpflege aktiv
                    </mat-label>
                    <mat-slide-toggle [disabled]="!isWestnetzAdmin"
                                      [(ngModel)]="netzbetreiber.erzeugungsAnlagenPflegeAktiv"
                                      name="erzeugungsAnlagenPflegeAktiv" data-qa="erzeugungsAnlagenPflegeAktiv-toggle">
                        @if (netzbetreiber.erzeugungsAnlagenPflegeAktiv) {
                            <mat-label>Ja</mat-label>
                        } @else {
                            Nein
                        }
                    </mat-slide-toggle>
                    <input hidden matInput>
                </mat-form-field>
                @if (isWestnetzAdmin) {
                    <mat-form-field>
                        <mat-label>Schaltleitungen</mat-label>
                        <mat-select [(ngModel)]="netzbetreiber.schaltleitungen"
                                    [compareWith]="compareSchaltleitungen"
                                    [disabled]="!isWestnetzAdmin"
                                    id="schaltleitungenList"
                                    multiple
                                    name="schaltleitungenList">
                            @for (schaltleitung of availableSchaltleitungen | async; track schaltleitung.id) {
                                <mat-option [value]="schaltleitung">
                                    {{ schaltleitung.name }} ({{ schaltleitung.kuerzel }})
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                }
                @if (!isWestnetzAdmin) {
                    <mat-form-field>
                        <mat-label>Schaltleitungen</mat-label>
                        <input [(ngModel)]="schaltleitungenReadonly"
                               [disabled]="true"
                               [readonly]="true"
                               matInput
                               name="schaltleitungenReadonly"/>
                    </mat-form-field>
                }
                @if (isWestnetzAdmin) {
                    <mat-form-field>
                        <mat-label>Kundenbetreuer</mat-label>
                        <mat-select [(ngModel)]="netzbetreiber.kundenbetreuerList"
                                    [compareWith]="compareKundenbetreuer"
                                    id="kundenbetreuerList"
                                    multiple
                                    name="kundenbetreuerList">
                            @for (kundenbetreuer of availableKundenbetreuer | async; track kundenbetreuer.id) {
                                <mat-option
                                    [value]="kundenbetreuer">{{ kundenbetreuer.nachname }}
                                    , {{ kundenbetreuer.vorname }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                }
                @if (!isWestnetzAdmin) {
                    <mat-form-field>
                        <mat-label>Kundenbetreuer</mat-label>
                        <input [(ngModel)]="kundenbetreuerReadonly"
                               [disabled]="true"
                               [readonly]="true"
                               matInput
                               name="kundenbetreuerReadonly"/>
                    </mat-form-field>
                }
                <h3>Datenabfrage</h3>
                <mat-form-field class="no-input">
                    <mat-label>
                        Teilnehmer aktive Datenabfrage
                    </mat-label>
                    <mat-slide-toggle [disabled]="!isWestnetzAdmin" [(ngModel)]="netzbetreiber.datenAbfrageAktiv"
                                      name="datenAbfrageAktiv" data-qa="datenAbfrageAktiv-toggle">
                        @if (netzbetreiber.datenAbfrageAktiv) {
                            <mat-label>Ja</mat-label>
                        } @else {
                            Nein
                        }
                    </mat-slide-toggle>
                    <input hidden matInput>
                </mat-form-field>
                <h3>Reduzierungsart</h3>
                <div fxLayout="row" class="gap">
                    <mat-form-field class="no-input">
                        <mat-label>
                            Einspeisung
                        </mat-label>
                        <mat-slide-toggle [disabled]="!isWestnetzAdmin"
                                          [(ngModel)]="netzbetreiber.reduzierungsarten.einspeisereduzierung"
                                          data-qa="reduzierungsarten-einspeisereduzierung-toggle"
                                          name="reduzierungsarten-einspeisereduzierung">
                            @if (netzbetreiber.reduzierungsarten.einspeisereduzierung) {
                                <mat-label>Ja
                                </mat-label>
                            } @else {
                                Nein
                            }
                        </mat-slide-toggle>
                        <input hidden matInput>
                    </mat-form-field>
                    <mat-form-field class="no-input">
                        <mat-label>
                            Lastreduzierung
                        </mat-label>
                        <mat-slide-toggle [disabled]="!isWestnetzAdmin"
                                          [(ngModel)]="netzbetreiber.reduzierungsarten.lastreduzierung"
                                          data-qa="reduzierungsarten-lastreduzierung-toggle"
                                          name="reduzierungsarten-lastreduzierung">
                            @if (netzbetreiber.reduzierungsarten.lastreduzierung) {
                                <mat-label>Ja</mat-label>
                            } @else {
                                Nein
                            }
                        </mat-slide-toggle>
                        <input matInput hidden>
                    </mat-form-field>
                </div>
            </fieldset>
            <!-- KASKADENKONTAKT -->
            <fieldset>
                <legend>Kontaktdaten operative Kaskade</legend>
                <h3>Schaltberechtigt</h3>
                <mat-form-field>
                    <mat-label>Telefonnr.</mat-label>
                    <input #telefonAlarmierungKaskade="ngModel"
                           [(ngModel)]="netzbetreiber.kaskadenKontakt.telefonAlarmierungKaskade"
                           [disabled]="isWestnetzUser"
                           [readonly]="isWestnetzUser"
                           [required]="isStadtwerkUser"
                           matInput
                           name="telefonAlarmierungKaskade"
                           pattern="^\+\d{1,15}$"/>
                    <mat-hint>Nutzung für die Alarmierung im Kaskadenfall</mat-hint>
                    @if (telefonAlarmierungKaskade?.errors?.pattern) {
                        <mat-error
                        >
                            Diese Telefonnr. entspricht nicht dem internationalen E.164-Format, das aus einem + mit
                            maximal 15
                            darauffolgenden Ziffern ohne Leerzeichen oder Schrägstriche besteht. Bsp: +492011234567
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field>
                    <mat-label>E-Mail</mat-label>
                    <input #emailAlarmierungKaskade="ngModel"
                           [(ngModel)]="netzbetreiber.kaskadenKontakt.emailAlarmierungKaskade"
                           [disabled]="isWestnetzUser"
                           [pattern]="EMAIL_PATTERN"
                           [readonly]="isWestnetzUser"
                           [required]="isStadtwerkUser"
                           matInput
                           name="emailAlarmierungKaskade"/>
                    <mat-hint>Nutzung für die Alarmierung im Kaskadenfall</mat-hint>
                    @if (emailAlarmierungKaskade?.errors?.pattern) {
                        <mat-error
                        >
                            Diese E-Mail-Adresse scheint nicht gültig zu sein
                        </mat-error>
                    }
                </mat-form-field>
                <h3 class="topmargin">Informativ</h3>
                <mat-form-field>
                    <mat-label>Telefonnr.</mat-label>
                    <input #telefonBereitschaft="ngModel"
                           [(ngModel)]="netzbetreiber.kaskadenKontakt.telefonBereitschaft"
                           [disabled]="isWestnetzUser"
                           [readonly]="isWestnetzUser"
                           matInput
                           name="telefonBereitschaft"
                           pattern="^\+\d{1,15}$"/>
                    <mat-hint>Nutzung zur Information im Kaskadenfall</mat-hint>
                    @if (telefonBereitschaft?.errors?.pattern) {
                        <mat-error
                        >
                            Diese Telefonnr. entspricht nicht dem internationalen E.164-Format, das aus einem + mit
                            maximal 15
                            darauffolgenden Ziffern ohne Leerzeichen oder Schrägstriche besteht. Bsp: +492011234567
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field>
                    <mat-label>E-Mail</mat-label>
                    <input #emailInformationKaskade="ngModel"
                           [(ngModel)]="netzbetreiber.kaskadenKontakt.emailInformationKaskade"
                           [disabled]="isWestnetzUser"
                           [pattern]="EMAIL_PATTERN"
                           [readonly]="isWestnetzUser"
                           matInput
                           name="emailInformationKaskade"/>
                    <mat-hint>Nutzung zur Information im Kaskadenfall</mat-hint>
                    @if (emailInformationKaskade?.errors?.pattern) {
                        <mat-error
                        >
                            Diese E-Mail-Adresse scheint nicht gültig zu sein
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Satellitentelefonnr. (Inmarsat)</mat-label>
                    <input #satellitenTelefonInmarsat="ngModel"
                           [(ngModel)]="netzbetreiber.kaskadenKontakt.satellitenTelefonInmarsat"
                           [disabled]="isWestnetzUser"
                           [readonly]="isWestnetzUser"
                           matInput
                           name="satellitenTelefonInmarsat"/>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Satellitentelefonnr. (Iridium)</mat-label>
                    <input #satellitenTelefonIridium="ngModel"
                           [(ngModel)]="netzbetreiber.kaskadenKontakt.satellitenTelefonIridium"
                           [disabled]="isWestnetzUser"
                           [readonly]="isWestnetzUser"
                           matInput
                           name="satellitenTelefonIridium"/>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Telefaxnr.</mat-label>
                    <input #telefax="ngModel"
                           [(ngModel)]="netzbetreiber.kaskadenKontakt.telefax"
                           [disabled]="isWestnetzUser"
                           [readonly]="isWestnetzUser"
                           matInput
                           name="telefax"
                           pattern="^\+\d{1,15}$"/>
                    @if (telefax?.errors?.pattern) {
                        <mat-error
                        >
                            Diese Telefaxnr. entspricht nicht dem internationalen E.164-Format, das aus einem + mit
                            maximal 15
                            darauffolgenden Ziffern ohne Leerzeichen oder Schrägstriche besteht. Bsp: +492011234567
                        </mat-error>
                    }
                </mat-form-field>
            </fieldset>
            <fieldset>
                <legend>Kontaktdaten informatorische Kaskade</legend>
                <h3>TNB-Portal</h3>
                @if (isStadtwerkUser) {
                    <div class="email-hint">
                        <mat-hint>Es können bis zu vier E-Mail-Adressen angegeben werden.</mat-hint>
                    </div>
                }
                <mat-form-field>
                    <mat-label>E-Mail</mat-label>
                    <input #emailKommunikation="ngModel"
                           [(ngModel)]="netzbetreiber.kaskadenKontakt.emailKommunikation"
                           [disabled]="isWestnetzUser"
                           [pattern]="EMAIL_PATTERN"
                           [readonly]="isWestnetzUser"
                           [required]="isStadtwerkUser"
                           matInput
                           name="emailKommunikation"/>
                    @if (emailKommunikation?.errors?.pattern) {
                        <mat-error
                        >
                            Diese E-Mail-Adresse scheint nicht gültig zu sein
                        </mat-error>
                    }
                </mat-form-field>
                @if (emailKommunikationInputFieldIndex > 1) {
                    <mat-form-field>
                        <mat-label>E-Mail 2</mat-label>
                        <input #emailKommunikation2="ngModel"
                               [(ngModel)]="netzbetreiber.kaskadenKontakt.emailKommunikation2"
                               [disabled]="isWestnetzUser"
                               [pattern]="EMAIL_PATTERN"
                               [readonly]="isWestnetzUser"
                               matInput
                               name="emailKommunikation2"/>
                        @if (emailKommunikation2?.errors?.pattern) {
                            <mat-error
                            >
                                Diese E-Mail-Adresse scheint nicht gültig zu sein
                            </mat-error>
                        }
                    </mat-form-field>
                }
                @if (emailKommunikationInputFieldIndex > 2) {
                    <mat-form-field>
                        <mat-label>E-Mail 3</mat-label>
                        <input #emailKommunikation3="ngModel"
                               [(ngModel)]="netzbetreiber.kaskadenKontakt.emailKommunikation3"
                               [disabled]="isWestnetzUser"
                               [pattern]="EMAIL_PATTERN"
                               [readonly]="isWestnetzUser"
                               matInput
                               name="emailKommunikation3"/>
                        @if (emailKommunikation3?.errors?.pattern) {
                            <mat-error
                            >
                                Diese E-Mail-Adresse scheint nicht gültig zu sein
                            </mat-error>
                        }
                    </mat-form-field>
                }
                @if (emailKommunikationInputFieldIndex > 3) {
                    <mat-form-field>
                        <mat-label>E-Mail 4</mat-label>
                        <input #emailKommunikation4="ngModel"
                               [(ngModel)]="netzbetreiber.kaskadenKontakt.emailKommunikation4"
                               [disabled]="isWestnetzUser"
                               [pattern]="EMAIL_PATTERN"
                               [readonly]="isWestnetzUser"
                               matInput
                               name="emailKommunikation4"/>
                        @if (emailKommunikation4?.errors?.pattern) {
                            <mat-error
                            >
                                Diese E-Mail-Adresse scheint nicht gültig zu sein
                            </mat-error>
                        }
                    </mat-form-field>
                }
                @if (isStadtwerkUser) {
                    <button (click)="emailKommunikationInputFieldIndex = emailKommunikationInputFieldIndex + 1"
                            [disabled]="emailKommunikationInputFieldIndex >= 4"
                            id="addEmailCommunication" matButton="filled"
                            aria-label="Weitere Email zur Kommunikation hinzufügen">
                        <mat-icon>add</mat-icon>
                        Weitere E-Mail
                    </button>
                }
                <h3 class="topmargin">Adresse</h3>
                <div class="flex">
                    <mat-form-field>
                        <mat-label>Strasse</mat-label>
                        <input #strasse="ngModel"
                               [(ngModel)]="netzbetreiber.adresse.strasse"
                               [disabled]="isWestnetzUser"
                               [readonly]="isWestnetzUser"
                               matInput
                               name="strasse"/>
                    </mat-form-field>
                    <mat-form-field class="w-20">
                        <mat-label>Hausnr.</mat-label>
                        <input #hausnummer="ngModel"
                               [(ngModel)]="netzbetreiber.adresse.hausnummer"
                               [disabled]="isWestnetzUser"
                               [readonly]="isWestnetzUser"
                               matInput
                               name="hausnummer"/>
                    </mat-form-field>
                </div>
                <div class="flex">
                    <mat-form-field class="w-35">
                        <mat-label>Postleitzahl</mat-label>
                        <input #plz="ngModel"
                               [(ngModel)]="netzbetreiber.adresse.plz"
                               [disabled]="isWestnetzUser"
                               [readonly]="isWestnetzUser"
                               matInput
                               name="plz"
                               pattern="[0-9]{5}"/>
                        @if (plz?.errors?.pattern) {
                            <mat-error
                            >
                                Bitte geben Sie eine fünfstellige Postleitzahl ein
                            </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Stadt</mat-label>
                        <input #stadt="ngModel"
                               [(ngModel)]="netzbetreiber.adresse.stadt"
                               [disabled]="isWestnetzUser"
                               [readonly]="isWestnetzUser"
                               matInput
                               name="stadt"/>
                    </mat-form-field>
                </div>
            </fieldset>
        </div>
    </form>
}
